import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import './FigBotButton.css';

const FigBotButton = ({ onClick }) => {
  return (
    <button className="figbot-button" onClick={onClick}>
      <FontAwesomeIcon icon={faRobot} className="fa-robot" style={{ marginRight: '8px' }} />
      <span className="figbot-text">FigBot</span>
    </button>
  );
};

export default FigBotButton;
